import { headerBlock, footerBlock, buildEmpleadorBlock } from '../blocks/header'
import { buildPersonasRows, buildEvolucionRows } from '../blocks/tablas'

export const buildPage3 = ({
  today,
  periodoDesde,
  periodoHasta,
  totalPages,
  empleador,
  reportData,
  topJudiciales,
  topEvolucionSiniestros,
  firma = '',
}) => `
  <div class="page page-break">
    ${headerBlock(today, periodoDesde, periodoHasta)}
    ${buildEmpleadorBlock(empleador, reportData)}

    <!-- TOP JUDICIALES -->
    <div class="table-section">
      <div class="section-title">TOTAL HISTÓRICO DE PERSONAS TRABAJADORAS CON MÁS JUICIOS</div>
      <table class="main">
        <tr>
          <th>CUIL</th>
          <th style="width:163.31px;">Apellido y nombre</th>
          <th class="r">Denuncias</th>
          <th class="r">A.T</th>
          <th class="r">I.T</th>
          <th class="r">E.P</th>
          <th class="r">Juicios</th>
          <th class="r">Autodenuncias</th>
          <th>Estado activo</th>
        </tr>
        ${buildPersonasRows(topJudiciales, 'No se registran juicios asociados a siniestros')}
      </table>
    </div>

    <!-- EVOLUCIÓN MENSUAL DE SINIESTROS -->
    <div class="table-section">
      <div class="section-title">EVOLUCIÓN MENSUAL DE SINIESTROS</div>
      <table class="main">
        <tr>
          <th style="text-align:center;">Período</th>
          <th style="text-align:center;">Nómina</th>
          <th style="text-align:center;">Stro AT</th>
          <th style="text-align:center;">Stro IT</th>
          <th style="text-align:center;">Stro EP</th>
          <th style="text-align:center;">Stro Total</th>
          <th style="text-align:center;">Fr. AT</th>
          <th style="text-align:center;">Fr. IT</th>
          <th style="text-align:center;">Fr. EP</th>
          <th style="text-align:center;">Fr. Total</th>
        </tr>
        ${buildEvolucionRows(topEvolucionSiniestros)}
      </table>
    </div>

    <div style="margin-top:auto;">
      <div style="font-size:10px;color:#666;line-height:1.4;margin-bottom:63.6px;">
        <p>Denuncias de COVID-19: Se incluyen únicamente en el indicador Tipo de Accidente</p>
        <p>Frecuencia Siniestral: Se calcula la relación de los siniestros aceptados sobre el promedio de trabajadores (cápitas) de los últimos 12 meses.</p>
        <p>Frecuencia Judicial: Mide la cantidad de juicios iniciados sobre el total de siniestros denunciados en los últimos 12 meses.</p>
        <p>Evolución Mensual: Muestra los siniestros y la frecuencia siniestral por tipo de accidente, basándose en un cálculo de los últimos 12 meses del período indicado.</p>
        <p>Personas trabajadoras con más juicios: lista el top 10 de juicios históricos, desde el inicio del contrato</p>
      </div>

      <div style="display:flex;gap:20px;margin-bottom:8px;">
        <div style="flex:1;display:flex;flex-direction:column;align-items:center;">
          ${firma ? `<img src="${firma}" style="max-height:60px;object-fit:contain;" />` : ''}
          <div style="margin-top:auto;width:60%;border-bottom:0.5px solid #3c3c3b;"></div>
          <div style="font-size:9px;font-weight:600;margin-top:7px;">Firma</div>
        </div>
        <div style="flex:1;display:flex;flex-direction:column;align-items:center;">
          <div style="margin-top:auto;font-size:9px;color:#3c3c3b;text-align:center;margin-bottom:8px;">Ing. Guillermo Herrmann, Gerente de Prevención</div>
          <div style="width:60%;border-bottom:0.5px solid #3c3c3b;"></div>
          <div style="font-size:9px;font-weight:600;margin-top:7px;">Aclaración</div>
        </div>
      </div>

      ${footerBlock(3, totalPages)}
    </div>
  </div>`
